import { useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { syncWithFdsAdmin } from 'services/users'
import { useNotification } from 'components/Notification'

/**
 * Mutation hook for syncing a user with FDS Admin.
 * Tracks which row is currently syncing via syncingRowId.
 * @returns {object} - { syncUser, syncUserForRow, isSyncing, syncingRowId }
 */
function useSyncUser() {
  const { createNotification } = useNotification()
  const [syncingRowId, setSyncingRowId] = useState(null)

  const { mutate: syncUser, isPending: isSyncing } = useMutation({
    mutationFn: syncWithFdsAdmin,
    onSuccess: () => {
      createNotification({
        message: 'Successfully synced user with FDS Admin',
        variant: 'success',
      })
    },
    onError: error => {
      const message =
        error?.response?.data?.errors?.[0] || error?.message || 'Failed to sync user with FDS Admin'
      createNotification({ message, variant: 'error' })
    },
    onSettled: () => setSyncingRowId(null),
  })

  const syncUserForRow = (rowId, serialNumbers) => {
    setSyncingRowId(rowId)
    syncUser(serialNumbers)
  }

  return { syncUser, syncUserForRow, isSyncing, syncingRowId }
}

export default useSyncUser
